/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CashflowForecastSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The CashflowForecastSettings model module.
   * @module model/CashflowForecastSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CashflowForecastSettings</code>.
   * @alias module:model/CashflowForecastSettings
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>CashflowForecastSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CashflowForecastSettings} obj Optional instance to populate.
   * @return {module:model/CashflowForecastSettings} The populated <code>CashflowForecastSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AccountBalance')) {
        obj['AccountBalance'] = ApiClient.convertToType(data['AccountBalance'], 'Number');
      }
      if (data.hasOwnProperty('AccountBalanceLimit')) {
        obj['AccountBalanceLimit'] = ApiClient.convertToType(data['AccountBalanceLimit'], 'Number');
      }
      if (data.hasOwnProperty('EstimatedSalesReach')) {
        obj['EstimatedSalesReach'] = ApiClient.convertToType(data['EstimatedSalesReach'], 'Number');
      }
      if (data.hasOwnProperty('EstimatedCostsReach')) {
        obj['EstimatedCostsReach'] = ApiClient.convertToType(data['EstimatedCostsReach'], 'Number');
      }
      if (data.hasOwnProperty('ForecastEnabled')) {
        obj['ForecastEnabled'] = ApiClient.convertToType(data['ForecastEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('UseForecastModel')) {
        obj['UseForecastModel'] = ApiClient.convertToType(data['UseForecastModel'], 'Boolean');
      }
      if (data.hasOwnProperty('VATSimulationPeriodTypeID')) {
        obj['VATSimulationPeriodTypeID'] = ApiClient.convertToType(data['VATSimulationPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ExpiredSalesReceivablesDistributionEnabled')) {
        obj['ExpiredSalesReceivablesDistributionEnabled'] = ApiClient.convertToType(data['ExpiredSalesReceivablesDistributionEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CashIndicatorID')) {
        obj['CashIndicatorID'] = ApiClient.convertToType(data['CashIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodProfitIndicatorID')) {
        obj['PeriodProfitIndicatorID'] = ApiClient.convertToType(data['PeriodProfitIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('EquityIndicatorID')) {
        obj['EquityIndicatorID'] = ApiClient.convertToType(data['EquityIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('VATIndicatorID')) {
        obj['VATIndicatorID'] = ApiClient.convertToType(data['VATIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('EquityVisible')) {
        obj['EquityVisible'] = ApiClient.convertToType(data['EquityVisible'], 'Boolean');
      }
      if (data.hasOwnProperty('ReceivablesTurnoverIndicatorID')) {
        obj['ReceivablesTurnoverIndicatorID'] = ApiClient.convertToType(data['ReceivablesTurnoverIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('PayablesTurnoverIndicatorID')) {
        obj['PayablesTurnoverIndicatorID'] = ApiClient.convertToType(data['PayablesTurnoverIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Number} AccountBalance
   * @default 0.0
   */
  exports.prototype['AccountBalance'] = 0.0;
  /**
   * @member {Number} AccountBalanceLimit
   * @default 0.0
   */
  exports.prototype['AccountBalanceLimit'] = 0.0;
  /**
   * @member {Number} EstimatedSalesReach
   * @default 0.0
   */
  exports.prototype['EstimatedSalesReach'] = 0.0;
  /**
   * @member {Number} EstimatedCostsReach
   * @default 0.0
   */
  exports.prototype['EstimatedCostsReach'] = 0.0;
  /**
   * @member {Boolean} ForecastEnabled
   * @default false
   */
  exports.prototype['ForecastEnabled'] = false;
  /**
   * @member {Boolean} UseForecastModel
   * @default false
   */
  exports.prototype['UseForecastModel'] = false;
  /**
   * @member {Integer} VATSimulationPeriodTypeID
   */
  exports.prototype['VATSimulationPeriodTypeID'] = undefined;
  /**
   * @member {Boolean} ExpiredSalesReceivablesDistributionEnabled
   * @default false
   */
  exports.prototype['ExpiredSalesReceivablesDistributionEnabled'] = false;
  /**
   * @member {Integer} CashIndicatorID
   * @default 0
   */
  exports.prototype['CashIndicatorID'] = 0;
  /**
   * @member {Integer} PeriodProfitIndicatorID
   * @default 0
   */
  exports.prototype['PeriodProfitIndicatorID'] = 0;
  /**
   * @member {Integer} EquityIndicatorID
   * @default 0
   */
  exports.prototype['EquityIndicatorID'] = 0;
  /**
   * @member {Integer} VATIndicatorID
   * @default 0
   */
  exports.prototype['VATIndicatorID'] = 0;
  /**
   * @member {Boolean} EquityVisible
   * @default false
   */
  exports.prototype['EquityVisible'] = false;
  /**
   * @member {Integer} ReceivablesTurnoverIndicatorID
   */
  exports.prototype['ReceivablesTurnoverIndicatorID'] = undefined;
  /**
   * @member {Integer} PayablesTurnoverIndicatorID
   */
  exports.prototype['PayablesTurnoverIndicatorID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


